<template>
  <div id="PoliciesPopup">
    <div class="content policies">
      <div class="my-content">
        <p class="title">Season Ticket Holder Policies</p>
        <p class="title-small">Fan Code of Conduct <img src="~@/assets/respect.jpg" /></p>
        <p>The Denver Broncos are committed to creating a safe, comfortable, and enjoyable experience for all fans, both in the stadium and in the parking lots. We want all fans attending our games to enjoy the experience in a responsible fashion. When attending a game, you are required to refrain from the following behaviors: <a href="https://www.denverbroncos.com/stadium/codeofconduct" class="caps" target="_blank" onClick="return submitHit('FanCode', true);">Read More</a>.</p>
        <p class="title-small">Season Ticket Account Policies</p>
        <div class="policy">
          <div class="copy">
            <p class="larger">Season Ticket Accounts</p>
            <p>A Season Ticket Account is a revocable license issued annually by Denver Broncos Team, LLC. ('Denver Broncos' or 'Broncos'), as licensor. Season ticket accounts are subject to the terms, conditions and policies (including the 'Fan Code of Conduct'), established from time to time by the Broncos, including, without limitation, the Ticket Terms available at <a href="https://am.ticketmaster.com/broncos/terms" target="_blank">https://am.ticketmaster.com/broncos/terms</a> (the “Ticket Terms”). The current policies may be modified and/or supplemented at any time by the Denver Broncos. Any modifications or new policies will be effective when adopted.</p>
          </div>
        </div>
        <div class="policy">
          <div class="copy">
            <p class="larger">Purchase from Year to Year [Renewal]</p>
            <p>Season Ticket Account Holders are valued customers of the Denver Broncos. However, the opportunity to purchase season ticket accounts from year-to-year, at any seat location, is a privilege granted by the Broncos, which may be revoked by the Broncos at any time. Neither a Season Ticket Account, nor the opportunity to purchase a Season Ticket Account from year-to-year, constitutes any form of legal or equitable right, including without limitation an express or implied contract, lease, option, right of first refusal, implied trust, or expectancy interest. There is no automatic right to purchase a Season Ticket Account from year-to-year, nor is there any guarantee that this privilege will be offered or granted by the Broncos. Season Ticket Account Holders should not form any manner of reliance on the privilege to purchase a Season Ticket Account from year-to-year, nor there be any prescriptive right to purchase a Season Ticket Account annually. The privilege to purchase a Season Ticket Account from year-to-year is not 'property' and creates no property rights whatsoever under state statutory or common law or under the United States Bankruptcy Code. Location of seats in a Season Ticket Account from year-to-year shall be determined by the Broncos in its sole discretion.</p>
          </div>
        </div>
        <div class="policy">
          <div class="copy">
            <p class="larger">Limited Transfer Policy - Bankruptcy</p>
            <p>Except as expressly set forth in this section, season tickets and season ticket accounts are nontransferable, including without limitation assignment or transfer to a third-party, change of names (except upon submission of a marriage certificate or court order evidencing the same), or purported assignments to an 'in care of' status. A Season Ticket Account Holder may not either voluntarily or by operation of law, assign, encumber, sublicense, or otherwise transfer a Season Ticket Account (collectively, 'Transfer'), EXCEPT that a Season Ticket Account Holder shall be permitted to Transfer a Season Ticket Account (i) to an Affiliate (defined below) if the Account Holder is a partnership, corporation or limited liability company (in which case the account must be transferred in its entirety); or (ii) to Immediate Family Members (defined bellow) if the Account Holder is an individual by reason of gift or death only (in which case the account may be transferred in whole or in part; provided, however, that if less than all of the seats in an account are transferred, the transferring party must designate which party is to be assigned the present priority number and the other party will be assigned a new priority number). For purposes of this section, 'Affiliate' means any entity controlling, controlled by or under common control (directly or indirectly) with the Season Ticket Account Holder ('control' shall mean the ownership of more than 50% of the controlled or controlling entity) and 'Immediate Family Members' means a parent, spouse, child or sibling. Season Ticket Accounts shall not be deemed to be property of an estate in bankruptcy and are not transferable under the United States Bankruptcy Code. In the event that a Season Ticket Account Holder files for protection under any chapter of Bankruptcy Code, the subject Season Ticket Account shall immediately become void and of no further force and effect, and the Broncos shall be entitled to resell the Season Ticket Account to a third-party in its sole and complete discretion.</p>
            <p>If the Season Ticket Account Holder of Record is deceased, the court appointed Personal Representative may transfer the tickets to one or more of the deceased Season Ticket Account Holder's Immediate Family Members as defined above. The Personal Representative must provide documentation by the courts authorizing him or her to act in that capacity and information or documentation to demonstrate that the Proposed Account Holder is an Immediate Family Member.</p>
          </div>
        </div>
        <div class="policy">
          <div class="copy">
            <p class="larger">Revocation of Season Ticket Accounts - Disputes</p>
            <p>The Denver Broncos reserve the right to revoke any season ticket or Season Ticket Account without cause upon render of the refund based on the price printed on the face of the ticket. The Denver Broncos reserve the right to revoke any season ticket or Season Ticket Account with cause and without refund, because of violation of any of the policies of the Denver Broncos, misconduct (see the 'Fan Code of Conduct'), ticket ownership disputes involving the Broncos, and deceptive trade practices or fraud or misconduct. All costs of the Broncos, including attorney's fees, relating to any dispute concerning Season Ticket Account ownership costs, benefits and/or policies (whether or not the Broncos are named as a party in any litigation) will be charged to the Season Ticket Account Holder. There are no refunds or exchanges on Broncos season tickets or Season Ticket Accounts except as described herein or in the Ticket Terms.</p>
          </div>
        </div>
        <div class="policy">
          <div class="copy">
            <p class="larger">Americans with Disabilities Act Information</p>
            <p>The Denver Broncos fully meet and comply with the Americans with Disabilities Act and its implementing regulations to ensure that patrons with disabilities received full and equal enjoyment of the goods, services, facilities, privileges, advantages or accommodations provided by Empower Field at Mile High. The Broncos, in conjunction with representatives of the Colorado disabled community have prepared certain ADA-specific seating information, which is available in many Broncos publications, including the Denver Broncos web site: <a href="https://www.denverbroncos.com/tickets" target="_blank" onClick="return submitHit('Website', true);">www.denverbroncos.com/tickets</a>.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PoliciesPopup",
  computed: {
    ...mapState(["global"]),
  }
};
</script>

<style lang="scss" scoped>
#PoliciesPopup {
  width: 100%;
  max-width: 940px;
  background-color: #fff;
  margin: 0;
  div.content.policies {
    width: 100%;
    height: calc(100vh - 60px);
    overflow-y: auto;
    padding: 40px;
    div.my-content {
      p {
        text-align: left;
        @include nexaBold;
        color: $blue;
        font-size: 15px;
        line-height: 18px;
        margin-top: 20px;
        &.title {
          @include nexaBold;
          font-size: 40px;
          line-height: 40px;
          margin-bottom: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid $blue;
          text-transform: uppercase;
          text-align: center;
          margin-bottom: 20px;
        }
        &.sub-title {
          @include nexaBold;
          font-size: 28px;
          line-height: 28px;
          text-transform: uppercase;
        }
        &.title-small {
          @include nofex;
          font-size: 20px;
          line-height: 20px;
          text-transform: uppercase;
          &.grey {
            color: #8f8f8f;
          }
          img {
            display: inline-block;
            position: relative;
            vertical-align: middle;
            height: 20px;
            margin-left: 10px;
          }
        }
        a {
          color: $orange;
          text-decoration: underline;
          &.caps {
            text-transform: uppercase;
            @include nexaBold;
          }
        }
      }
      ul {
        display: block;
        position: relative;
        width: 100%;
        height: auto;
        text-align: left;
        list-style: outside disc;
        margin-top: 5px;
        margin-top: 10px;
        li {
          margin-left: 15px;
          margin-top: 10px;
          padding: 1px 0;
          @include nexaBold;
          font-size: 15px;
          line-height: 18px;
          color: $blue;
          strong {
            @include nexaBold;
          }
        }
      }
      div.policy {
        display: flex;
        position: relative;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 20px;
        span.number {
          display: inline-block;
          position: relative;
          width: 20px;
          height: auto;
          color: $orange;
          @include nexaBold;
          font-size: 18px;
          line-height: 20px;
          text-align: left;
        }
        div.copy {
          display: inline-block;
          position: relative;
          width: calc(100% - 20px);
          height: auto;
          p {
            font-size: 16px;
            line-height: 20px;
            margin-top: 15px;
            &:first-child {
              margin-top: 0px;
            }
            &.larger {
              @include nofex;
              font-size: 18px;
              line-height: 20px;
              text-transform: uppercase;
            }
          }
        }
      }
    }
  }
}
</style>